import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class BillingListRow {
  static props = ['href', 'name', 'planName', 'status', 'createdAt', 'userEmail'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.name }}
    td.pr-4 {{ Props.planName }}
    td.pr-4 {{ Props.status }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.userEmail }}
  `;
}

export class BillingList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/billing/create"] Add billing
    <PageTitle title="Billing">
    table.resource-table[data-empty-title="No billing profiles yet" data-empty-description="Add billing details to manage plans and subscription status." data-empty-action="Add billing" data-empty-href="/billing/create"]
      thead
        th Name
        th.pr-4 Plan
        th.pr-4 Status
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#billing-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('billing'))
      .then(response => {
        appendDataToListTable('#billing-list-rows', response.data, BillingListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#billing-list-rows', error, 'Billing'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.name}`,
      name: item.name,
      planName: item.planName || '',
      status: item.status || '',
      createdAt: Util.formatDate(item.createdAt),
      userEmail: item.createdBy || ''
    };
  }
}
